import React from 'react';
import { useNavigate } from 'react-router-dom';
import { tours } from '../data/tours';

const Tours = () => {
  const navigate = useNavigate();

  const handleBookTour = (tour) => {
    navigate('/contact', { state: { 
      selectedTour: tour.title,
      hasMinimumBooking: tour.hasMinimumBooking,
      minimumPeople: tour.minimumPeople
    } });
  };

  const displayTours = tours.filter(tour => tour.key !== 'custom');

  return (
    <main className="tours" role="main">
      <div className="container">
        <h1>Our Tour Packages</h1>
        <p className="tours-intro">
          Discover amazing destinations with our carefully crafted tour experiences
        </p>
        
        <section className="tours-grid" aria-label="Available tour packages">
          {displayTours.map(tour => (
            <article key={tour.id} className="tour-card" aria-labelledby={`tour-title-${tour.id}`}>
              <div className="tour-header">
                <h2 id={`tour-title-${tour.id}`}>{tour.title}</h2>
                <div className="tour-meta">
                  <span className="duration" aria-label={`Duration: ${tour.duration}`}>{tour.duration}</span>
                  <span className="price" aria-label={`Price: ${tour.price}${tour.perPerson ? ' per person' : ''}`}>
                    {tour.price}
                    {tour.perPerson && <span className="per-person">per person</span>}
                  </span>
                </div>
              </div>
              <p className="tour-description">{tour.description}</p>
              <ul className="tour-features" aria-label="Tour features">
                {tour.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <div className="minimum-booking-container">
                {tour.hasMinimumBooking ? (
                  <div className="minimum-booking" aria-label={`Minimum booking requirement: ${tour.minimumPeople} people`}>
                    <span className="minimum-booking-text">
                      Minimum booking: {tour.minimumPeople} {tour.minimumPeople === 1 ? 'person' : 'people'}
                    </span>
                  </div>
                ) : (
                  <div className="minimum-booking-spacer"></div>
                )}
              </div>
              <button 
                className="btn btn-primary"
                onClick={() => handleBookTour(tour)}
                aria-label={`Book ${tour.title} tour`}
              >
                Book This Tour
              </button>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
};

export default Tours;